import {computed, signal} from "@preact/signals-react";
import {getCurrentDate} from "@ui-seeker/utils";


export const nextUserCheck = signal(null)
export const userData = signal({})
export const checkingLogging = signal(true)
export const imageModalData = signal({})

// Consumed by the vendored @app shell's WrapperPage (CommonFilters state).
// This project does not use common filters yet; defaults keep WrapperPage happy.
export const hasSearchedCommonFilters = signal(false)
export const isLoadingCommonFilters = signal(false)

// Computed
export const isLogged = computed(() => nextUserCheck.value && nextUserCheck.value >= getCurrentDate().getTime())
